export const QUOTES_ACTION_TYPES = {
  FETCH_QUOTE_START: 'QUOTES/FETCH_QUOTE_START',
  FETCH_QUOTE_SUCCESS: 'QUOTES/FETCH_QUOTE_SUCCESS',
  FETCH_QUOTE_FAILED: 'QUOTES/FETCH_QUOTE_FAILED',
};